<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2 id="label_ProjCreateMilestoneTitle">{{(mode === 'edit' ? translate?.general.buttons.edit.singular : translate?.general.buttons.new.singular)}} {{translate?.project.sections.sec6.singular}}</h2>
        </div>
        <button class="icon-btn" aria-label="Close" id="btn_ProjCreateMilestoneClose" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="flx-modal__body mp-body">
        <form [formGroup]="milestoneForm">
            <div class="status-field">
                <label class="field-label mandatory" id="label_ProjCreateMilestoneNameLabel">{{translate?.project.messages.giveThis}} {{translate?.project.sections.sec6.singular | lowercase}} {{translate?.project.messages.aName}}</label>
                <div class="field-row field-row--single">
                    <div>
                        <input pInputText id="input_ProjCreateMilestoneNameField" formControlName="name"
                            placeholder="{{translate?.general.messages.none}}" />
                        <div class="p-error text-10 mt-1" id="label_ProjCreateMilestoneNameError"
                            *ngIf="(submitted || milestoneForm.controls['name'].touched) && milestoneForm.controls['name'].invalid">
                            <span id="label_ProjCreateMilestoneNameRequiredError" *ngIf="milestoneForm.controls['name'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="status-field">
                <label class="field-label" id="label_ProjCreateMilestoneDescLabel">{{translate?.project.messages.milestoneDescriptionQuestion}} {{translate?.project.sections.sec6.singular | lowercase}}</label>
                <div class="field-row field-row--single">
                    <div>
                        <textarea pInputTextarea id="input_ProjCreateMilestoneDescField" formControlName="description" autocomplete="off" rows="3" placeholder="{{translate?.general.messages.none}}"></textarea>
                    </div>
                </div>
            </div>

            <div class="status-field">
                <label class="field-label" id="label_ProjCreateMilestoneDurationLabel">{{translate?.project.messages.howLongShouldThis}} {{translate?.project.sections.sec6.singular | lowercase}} {{translate?.project.messages.Last}}?</label>
                <div class="field-row--auto_range mp-row">
                    <div class="status-field">
                        <span class="field-label mandatory" id="label_ProjCreateMilestoneStartDateLabel">{{translate?.project.fields.startDate.singular}}</span>
                        <p-calendar id="picklist_ProjCreateMilestoneStartDateField" formControlName="startDate" dateFormat="d/m/yy"
                            placeholder="dd/mm/yy" styleClass="cal-btn" [showIcon]="true" appendTo="body"
                            [maxDate]="milestoneForm.get('endDate')?.value || undefined" (onSelect)="onDateChange()"></p-calendar>
                        <div class="p-error text-10" id="label_ProjCreateMilestoneStartDateError"
                            *ngIf="(submitted || milestoneForm.controls['startDate'].touched) && milestoneForm.controls['startDate'].invalid">
                            <span id="label_ProjCreateMilestoneStartDateRequiredError" *ngIf="milestoneForm.controls['startDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                            <span id="label_ProjCreateMilestoneStartDateRangeError" *ngIf="milestoneForm.controls['startDate'].errors?.afterEnd">{{translate?.project.validationFE.dateCannotBeAfterEndDate}}</span>
                        </div>
                    </div>
                    <span class="divider-two"><i class="fa-solid fa-minus"></i></span>
                    <div class="status-field">
                        <span class="field-label mandatory" id="label_ProjCreateMilestoneEndDateLabel">{{translate?.project.fields.endDate.singular}}</span>
                        <p-calendar id="picklist_ProjCreateMilestoneEndDateField" formControlName="endDate" dateFormat="d/m/yy" placeholder="dd/mm/yy"
                            styleClass="cal-btn" [showIcon]="true" appendTo="body"
                            [minDate]="milestoneForm.get('startDate')?.value || undefined" (onSelect)="onDateChange()"></p-calendar>
                        <div class="p-error text-10" id="label_ProjCreateMilestoneEndDateError"
                            *ngIf="(submitted || milestoneForm.controls['endDate'].touched) && milestoneForm.controls['endDate'].invalid">
                            <span id="label_ProjCreateMilestoneEndDateRequiredError" *ngIf="milestoneForm.controls['endDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                            <span id="label_ProjCreateMilestoneEndDateRangeError" *ngIf="milestoneForm.controls['endDate'].errors?.beforeStart">{{translate?.project.validationFE.dateCannotBeBeforeStartDate}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="status-field">
                <label class="field-label" id="label_ProjCreateMilestoneStatusLabel">{{translate?.project.messages.milestoneStatusQuestion}} {{translate?.project.sections.sec6.singular | lowercase}}?</label>
                <div class="field-row field-row--single">
                    <div>
                        <p-dropdown id="picklist_ProjCreateMilestoneStatusField" formControlName="status" [options]="statusOptions" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="flx-modal__footer">
        <button class="custella-btn-white" id="btn_ProjCreateMilestoneCancel" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button type="button" id="btn_ProjCreateMilestoneSave" [label]="translate?.general.buttons.save.singular" [loading]="saveInProgress"
            styleClass="h-32" (onClick)="onSave()"></p-button>
    </div>
</div>
